import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { IGroupProps } from "./interface";
import { RadioGroupContextProvider } from "./context";

const Group: React.FC<IGroupProps> = props => {
  const {
    prefixCls = "rc-radio-group",
    className,
    defaultValue = null,
    type,
    onChange,
    allowDeselect = false,
    name,
    children,
    darkStyle,
  } = props;

  const [value, setValue] = useState<string | number | Record<string, any>>(props.value || defaultValue);
  const [id, setId] = useState<string | number>(props.id);

  useEffect(() => {
    let mounted = true;
    if (defaultValue) {
      if (mounted) {
        setValue(defaultValue);
      }
    }
    return () => {
      mounted = false;
    };
  }, [defaultValue]);

  const onRadioChange = (ev: string | number | Record<string, any>, id?: string | number) => {
    const lastValue = value;
    const nextValue = allowDeselect && ev === lastValue ? null : ev;

    setValue(nextValue);

    if (allowDeselect && ev === lastValue) {
      setId(undefined);
    } else if (id !== undefined) {
      setId(id);
    }

    if (onChange && nextValue !== lastValue) {
      onChange(nextValue);
    }
  };

  useEffect(() => {
    setValue(props.value);
    if (props.value == null) {
      setId(undefined);
    }
  }, [props.value]);

  useEffect(() => {
    setId(props.id);
  }, [props.id]);

  const radioGroupClassName = classNames(prefixCls, { [`${prefixCls}-t${type}`]: type }, className, {
    [`${prefixCls}-dark-style`]: darkStyle,
  });

  const clonedChildren = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { name });
    }
  });

  return (
    <RadioGroupContextProvider
      value={{
        onChange: onRadioChange,
        value,
        id,
        darkStyle: darkStyle,
      }}
    >
      <div className={radioGroupClassName}>{clonedChildren}</div>
    </RadioGroupContextProvider>
  );
};

export default Group;
